import { withoutSpace } from '../helpers.js';

const conditionsStr = "_themeLight,_themeDark,_dark,_light,_hover,_active,_pressed,_checked,_indeterminate,_unchecked,_focus,_focusVisible,_disabled,_visited,_selected,_current,_currentPage,_currentStep,_placeholder,_invalid,_expanded,_hasDisabled,_hasChecked,_hasUnchecked,_hasFocus,_hasFocusVisible,_hasInvalid,_hasExpanded,_hasPressed,_groupActive,_groupHover,_groupSelected,_groupSelectedHover,_groupFirst,_groupLast,_groupExpanded,_groupEnabled,_groupPressed,_groupHasPressed,_groupHasExpanded,_first,_last,_directChildren,_before,_after,xs,xsOnly,xsDown,sm,smOnly,smDown,md,mdOnly,mdDown,lg,lgOnly,lgDown,xl,xlOnly,xlDown,2xl,2xlOnly,2xlDown,xsToSm,xsToMd,xsToLg,xsToXl,xsTo2xl,smToMd,smToLg,smToXl,smTo2xl,mdToLg,mdToXl,mdTo2xl,lgToXl,lgTo2xl,xlTo2xl,_themeTranslated,_themeModernmt,base"
const conditions = new Set(conditionsStr.split(','))

const conditionRegex = /^@|&|&$/

export function isCondition(value){
  return conditions.has(value) || conditionRegex.test(value)
}

const underscoreRegex = /^_/
const conditionsSelectorRegex = /&|@/

export function finalizeConditions(paths){
  return paths.map((path) => {
    if (conditions.has(path)){
      return path.replace(underscoreRegex, '')
    }

    if (conditionsSelectorRegex.test(path)){
      return `[${withoutSpace(path.trim())}]`
    }

    return path
  })}

  export function sortConditions(paths){
    return paths.sort((a, b) => {
      const aa = isCondition(a)
      const bb = isCondition(b)
      if (aa && !bb) return 1
      if (!aa && bb) return -1
      return 0
    })
  }